import { render, staticRenderFns } from "./Voices.vue?vue&type=template&id=d743c50e"
import script from "./Voices.vue?vue&type=script&lang=js"
export * from "./Voices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports